import React from 'react';
import ReactDOM from 'react-dom/client';
import { userInfoService } from '@/infra/auth';
import App from './App';



(async () => {
    if (localStorage.getItem('auth_token')) {
      try {

          await userInfoService();
      } catch (e) {
          // ignore
      }
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(<App />);
    } else {
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(<App />);
    }
})();
